/**
 * Feature scripts for Product Display
 * 
 * Handles functionality for product features:
 * - Quick View
 * - Wishlist
 * - Compare
 * - Add to Cart AJAX
 */

(function($) {
    'use strict';

    // WCPS Features Object
    var PRODDISP_Features = {
        /**
         * Initialize
         */
        init: function() {
            this.initQuickView();
            this.initWishlist();
            this.initCompare();
            this.initAjaxAddToCart();
        },

        /**
         * Initialize Quick View
         */
        initQuickView: function() {
            // Quick view button click
            $(document).on('click', '.wcps-quickview', function(e) {
                e.preventDefault();
                
                var $button = $(this);
                var productId = $button.data('product-id');
                
                // Create modal if it doesn't exist
                if (!$('#wcps-quickview-modal').length) {
                    $('body').append('<div id="wcps-quickview-modal" class="wcps-modal"><div class="wcps-modal-content"><span class="wcps-modal-close">&times;</span><div class="wcps-modal-body"></div></div></div>');
                }
                
                var $modal = $('#wcps-quickview-modal');
                var $modalBody = $modal.find('.wcps-modal-body');
                
                // Show loading
                $modalBody.html('<div class="wcps-loading-spinner"></div>');
                $modal.addClass('wcps-modal-open');
                
                // Fetch product data with AJAX
                $.ajax({
                    url: proddisp_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'proddisp_quickview',
                        nonce: proddisp_params.nonce,
                        product_id: productId
                    },
                    success: function(response) {
                        if (response.success) {
                            $modalBody.html(response.data.html);
                            // Always force opacity to 1 as a fallback
                                $modalBody.find('.woocommerce-product-gallery').css('opacity', 1);

                                // Initialize product gallery if available
                                if ($.fn.wc_product_gallery) {
                                    $modalBody.find('.woocommerce-product-gallery').each(function() {
                                        var $gallery = $(this);
                                        if ($.fn.imagesLoaded) {
                                            $gallery.imagesLoaded(function() {
                                                $gallery.wc_product_gallery();
                                                $gallery.css('opacity', 1); // Fallback in case WooCommerce doesn't do it
                                            });
                                        } else {
                                            $gallery.wc_product_gallery();
                                            $gallery.css('opacity', 1); // Fallback
                                        }
                                    });
                                }
                            
                            // Initialize quantity buttons
                            PRODDISP_Features.initQuantityButtons($modalBody);
                            
                            // Initialize variation form
                            if ($.fn.wc_variation_form) {
                                $modalBody.find('.variations_form').each(function() {
                                    $(this).wc_variation_form();
                                });
                            }
                        } else {
                            $modalBody.html('<p class="wcps-error">' + response.data.message + '</p>');
                        }
                    },
                    error: function() {
                        $modalBody.html('<p class="wcps-error">Error loading product. Please try again.</p>');
                    }
                });
            });
            
            // Close quick view modal
            $(document).on('click', '.wcps-modal-close, .wcps-modal', function(e) {
                if (e.target === this) {
                    $('#wcps-quickview-modal').removeClass('wcps-modal-open');
                }
            });
            
            // Close on escape key
            $(document).on('keyup', function(e) {
                if (e.key === 'Escape' && $('#wcps-quickview-modal').hasClass('wcps-modal-open')) {
                    $('#wcps-quickview-modal').removeClass('wcps-modal-open');
                }
            });
        },

        /**
         * Initialize Wishlist modal and button functionality
         */
        initWishlist: function() {
            // Wishlist button click
            $(document).on('click', '.wcps-wishlist', function(e) {
                e.preventDefault();
                
                var $button = $(this);
                var productId = $button.data('product-id');
                
                // Check if AJAX is already in progress
                if ($button.hasClass('wcps-loading')) {
                    return;
                }
                
                // Add loading class
                $button.addClass('wcps-loading');
                
                // Toggle wishlist with AJAX
                $.ajax({
                    url: proddisp_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'proddisp_toggle_wishlist',
                        nonce: proddisp_params.nonce,
                        product_id: productId
                    },
                    success: function(response) {
                        $button.removeClass('wcps-loading');
                        
                        if (response.success) {
                            // Update button state
                            var $allButtons = $('.wcps-wishlist[data-product-id="' + productId + '"]');
                            if (response.data.in_wishlist) {
                                $allButtons.addClass('in-wishlist');
                                $allButtons.attr('title', 'Remove from Wishlist');
                                $allButtons.find('.wcps-btn-cta').text('Remove from Wishlist');
                                // Open the wishlist modal after adding
                                PRODDISP_Features.openWishlistModal();
                            } else {
                                $allButtons.removeClass('in-wishlist');
                                $allButtons.attr('title', 'Add to Wishlist');
                                $allButtons.find('.wcps-btn-cta').text('Add to Wishlist');
                            }
                            // Show notification
                            PRODDISP_Features.showNotification(response.data.message);
                            // Update wishlist counter if exists
                            if (response.data.count !== undefined) {
                                $('.wcps-wishlist-count').text(response.data.count);
                            }
                        } else {
                            PRODDISP_Features.showNotification(response.data.message, 'error');
                        }
                    },
                    error: function() {
                        $button.removeClass('wcps-loading');
                        PRODDISP_Features.showNotification('Error processing request. Please try again.', 'error');
                    }
                });
            });

            // Open wishlist modal
            $(document).on('click', '.wcps-wishlist-open-modal', function(e) {
                e.preventDefault();
                PRODDISP_Features.openWishlistModal();
            });
            
            // Close wishlist modal
            $(document).on('click', '.wcps-modal-close, .wcps-modal-overlay', function(e) {
                e.preventDefault();
                PRODDISP_Features.closeWishlistModal();
            });
            
            // Close modal when clicking outside content
            $(document).on('click', '#wcps-wishlist-modal', function(e) {
                if (e.target === this) {
                    PRODDISP_Features.closeWishlistModal();
                }
            });
            
            // Close modal with ESC key
            $(document).keyup(function(e) {
                if (e.key === "Escape" && $('#wcps-wishlist-modal').hasClass('wcps-modal-open')) {
                    PRODDISP_Features.closeWishlistModal();
                }
            });


        },

        // Wishlist open and close 
        openWishlistModal: function() {
            var $modal = $('#wcps-wishlist-modal');
            $modal.css('display', 'block');
            // Show modal
            $modal.addClass('wcps-modal-open');
            
            // Load wishlist content
            $.ajax({
                url: proddisp_params.ajax_url,
                type: 'POST',
                data: {
                    action: 'proddisp_get_wishlist',
                    nonce: proddisp_params.nonce
                },
                beforeSend: function() {
                    $('#wcps-wishlist-container').html('<div class="wcps-loading-spinner"></div>');
                },
                success: function(response) {
                    if (response.success) {
                        $('#wcps-wishlist-container').html(response.data.html);
                        
                        // Initialize remove buttons
                        PRODDISP_Features.initWishlistRemoveButtons();
                    } else {
                        $('#wcps-wishlist-container').html('<p class="wcps-error">Error loading wishlist.</p>');
                    }
                },
                error: function() {
                    $('#wcps-wishlist-container').html('<p class="wcps-error">Error loading wishlist. Please try again.</p>');
                }
            });
        },

        // Close wishlist modal
        closeWishlistModal: function() {
            $('#wcps-wishlist-modal').removeClass('wcps-modal-open');
            $('#wcps-wishlist-modal').css('display', 'none');
        },

        // Initialize wishlist remove buttons
        initWishlistRemoveButtons: function() {
            $('.wcps-wishlist-remove-item').on('click', function(e) {
                e.preventDefault();
                
                var $button = $(this);
                var productId = $button.data('product_id');
                var $productItem = $button.closest('.wcps-wishlist-product');
                
                // Add loading class
                $productItem.addClass('wcps-loading');
                
                // Remove from wishlist with AJAX
                $.ajax({
                    url: proddisp_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'proddisp_remove_from_wishlist',
                        nonce: proddisp_params.nonce,
                        product_id: productId
                    },
                    success: function(response) {
                        if (response.success) {
                            // Remove product from list with animation
                            $productItem.fadeOut(300, function() {
                                $(this).remove();
                                
                                // If no products left, show empty message
                                if ($('.wcps-wishlist-product').length === 0) {
                                    $('#wcps-wishlist-container').html('<p>' + proddisp_params.i18n.empty_wishlist + '</p>');
                                }
                            });
                            
                            // Update wishlist counter if exists
                            if (response.data.count !== undefined) {
                                $('.wcps-wishlist-count').text(response.data.count);
                            }
                            
                            // Update all wishlist buttons for this product
                            $('.wcps-wishlist-button[data-product-id="' + productId + '"]').removeClass('in-wishlist')
                                .attr('title', 'Add to Wishlist')
                                .find('.wcps-btn-cta').text('Add to Wishlist');
                                
                            // Show notification
                            PRODDISP_Features.showNotification(response.data.message);
                        } else {
                            $productItem.removeClass('wcps-loading');
                            PRODDISP_Features.showNotification(response.data.message, 'error');
                        }
                    },
                    error: function() {
                        $productItem.removeClass('wcps-loading');
                        PRODDISP_Features.showNotification('Error processing request. Please try again.', 'error');
                    }
                });
            });
        },

        /**
         * Initialize Compare functionality
         */
        initCompare: function() {
            // Compare button click
            $(document).on('click', '.wcps-compare', function(e) {
                e.preventDefault();
                
                var $button = $(this);
                var productId = $button.data('product-id');
                
                // Check if AJAX is already in progress
                if ($button.hasClass('wcps-loading')) {
                    return;
                }
                
                // Add loading class
                $button.addClass('wcps-loading');
                
                // Toggle compare with AJAX
                $.ajax({
                    url: proddisp_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'proddisp_toggle_compare',
                        nonce: proddisp_params.nonce,
                        product_id: productId
                    },
                    success: function(response) {
                        $button.removeClass('wcps-loading');
                        
                        if (response.success) {
                            // Update button state
                            if (response.data.in_compare) {
                                $button.addClass('in-compare');
                                $button.attr('title', 'Remove from Compare');
                                $button.find('.wcps-button-text').text('Remove from Compare');
                            } else {
                                $button.removeClass('in-compare');
                                $button.attr('title', 'Add to Compare');
                                $button.find('.wcps-button-text').text('Add to Compare');
                            }
                            
                            // Show notification
                            PRODDISP_Features.showNotification(response.data.message);
                            
                            // Update compare counter if exists
                            if (response.data.count !== undefined) {
                                $('.wcps-compare-count').text(response.data.count);
                            }
                            
                            // Show compare bar if products in compare
                            if (response.data.count > 0) {
                                if (!$('.wcps-compare-bar').length) {
                                    // Create compare bar
                                    PRODDISP_Features.createCompareBar(response.data.products);
                                } else {
                                    // Update compare bar
                                    PRODDISP_Features.updateCompareBar(response.data.products);
                                }
                            } else {
                                // Remove compare bar if no products
                                $('.wcps-compare-bar').remove();
                            }
                        } else {
                            PRODDISP_Features.showNotification(response.data.message, 'error');
                        }
                    },
                    error: function() {
                        $button.removeClass('wcps-loading');
                        PRODDISP_Features.showNotification('Error processing request. Please try again.', 'error');
                    }
                });
            });
            
            // Compare view button click
            $(document).on('click', '.wcps-compare-view-button', function(e) {
                e.preventDefault();
                
                var $modal = $('#wcps-compare-modal');
                
                if ($modal.length) {
                    // Modal already exists (created by PHP in footer)
                    var $modalBody = $modal.find('.wcps-modal-body');
                    
                    // Show loading
                    $modalBody.html('<div class="wcps-loading-spinner"></div>');
                    $modal.addClass('wcps-modal-open');
                } else {
                    // Create modal if it doesn't exist
                    $('body').append('<div id="wcps-compare-modal" class="wcps-modal"><div class="wcps-modal-content wcps-compare-modal-content"><span class="wcps-modal-close">&times;</span><div class="wcps-modal-body"></div></div></div>');
                    
                    $modal = $('#wcps-compare-modal');
                    var $modalBody = $modal.find('.wcps-modal-body');
                    
                    // Show loading
                    $modalBody.html('<div class="wcps-loading-spinner"></div>');
                    $modal.addClass('wcps-modal-open');
                }
                
                // Fetch compare data with AJAX
                $.ajax({
                    url: proddisp_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'proddisp_get_compare_table',
                        nonce: proddisp_params.nonce
                    },
                    success: function(response) {
                        if (response.success) {
                            $modalBody.html(response.data.html);
                        } else {
                            $modalBody.html('<p class="wcps-error">' + response.data.message + '</p>');
                        }
                    },
                    error: function() {
                        $modalBody.html('<p class="wcps-error">Error loading compare data. Please try again.</p>');
                    }
                });
            });
            
            // Handle clicking remove buttons inside the compare modal
            $(document).on('click', '.wcps-compare-remove', function(e) {
                e.preventDefault();
                
                var $button = $(this);
                var productId = $button.data('product-id');
                
                // Remove product from compare
                $.ajax({
                    url: proddisp_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'proddisp_toggle_compare',
                        nonce: proddisp_params.nonce,
                        product_id: productId
                    },
                    success: function(response) {
                        if (response.success) {
                            // Update compare buttons
                            $('.wcps-compare[data-product-id="' + productId + '"]').removeClass('in-compare');
                            
                            // Refresh the compare table
                            PRODDISP_Features.refreshCompareTable();
                            
                            // Update compare counter
                            if (response.data.count !== undefined) {
                                $('.wcps-compare-count').text(response.data.count);
                            }
                            
                            // Update or remove compare bar
                            if (response.data.count > 0) {
                                PRODDISP_Features.updateCompareBar(response.data.products);
                            } else {
                                $('.wcps-compare-bar').remove();
                                // Close modal if no products left
                                $('#wcps-compare-modal').removeClass('wcps-modal-open');
                            }
                        }
                    }
                });
            });
            
            // Remove from compare in compare bar
            $(document).on('click', '.wcps-compare-bar-item-remove', function(e) {
                e.preventDefault();
                
                var $button = $(this);
                var productId = $button.data('product-id');
                
                // Remove product from compare
                $.ajax({
                    url: proddisp_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'proddisp_toggle_compare',
                        nonce: proddisp_params.nonce,
                        product_id: productId
                    },
                    success: function(response) {
                        if (response.success) {
                            // Update compare buttons
                            $('.wcps-compare[data-product-id="' + productId + '"]').removeClass('in-compare');
                            
                            // Update compare counter
                            if (response.data.count !== undefined) {
                                $('.wcps-compare-count').text(response.data.count);
                            }
                            
                            // Update or remove compare bar
                            if (response.data.count > 0) {
                                PRODDISP_Features.updateCompareBar(response.data.products);
                            } else {
                                $('.wcps-compare-bar').remove();
                            }
                        }
                    }
                });
            });
            
            // Clear all compare
            $(document).on('click', '.wcps-compare-bar-clear', function(e) {
                e.preventDefault();
                
                // Clear compare
                $.ajax({
                    url: proddisp_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'proddisp_clear_compare',
                        nonce: proddisp_params.nonce
                    },
                    success: function(response) {
                        if (response.success) {
                            // Update compare buttons
                            $('.wcps-compare').removeClass('in-compare');
                            
                            // Update compare counter
                            $('.wcps-compare-count').text('0');
                            
                            // Remove compare bar
                            $('.wcps-compare-bar').remove();
                            
                            // Close compare modal if open
                            $('#wcps-compare-modal').removeClass('wcps-modal-open');
                        }
                    }
                });
            });
            
            // Close compare modal specifically
            $(document).on('click', '#wcps-compare-modal .wcps-modal-close, #wcps-compare-modal', function(e) {
                if (e.target === this) {
                    $('#wcps-compare-modal').removeClass('wcps-modal-open');
                }
            });
        },

        /**
         * Refresh Compare Table
         */
        refreshCompareTable: function() {
            var $modal = $('#wcps-compare-modal');
            var $modalBody = $modal.find('.wcps-modal-body');
            
            // Show loading
            $modalBody.html('<div class="wcps-loading-spinner"></div>');
            
            // Fetch compare data with AJAX
            $.ajax({
                url: proddisp_params.ajax_url,
                type: 'POST',
                data: {
                    action: 'proddisp_get_compare_table',
                    nonce: proddisp_params.nonce
                },
                success: function(response) {
                    if (response.success) {
                        $modalBody.html(response.data.html);
                    } else {
                        $modalBody.html('<p class="wcps-error">' + response.data.message + '</p>');
                    }
                },
                error: function() {
                    $modalBody.html('<p class="wcps-error">Error loading compare data. Please try again.</p>');
                }
            });
        },

        /**
         * Create Compare Bar
         */
        createCompareBar: function(products) {
            // Remove existing compare bar if any
            $('.wcps-compare-bar').remove();
            
            // Create compare bar HTML
            var html = '<div class="wcps-compare-bar">';
            html += '<div class="wcps-compare-bar-inner">';
            html += '<div class="wcps-compare-bar-items">';
            
            // Add products
            $.each(products, function(index, product) {
                html += '<div class="wcps-compare-bar-item" data-product-id="' + product.id + '">';
                html += '<div class="wcps-compare-bar-item-img">';
                html += '<img src="' + product.image + '" alt="' + product.name + '">';
                html += '<span class="wcps-compare-bar-item-remove" data-product-id="' + product.id + '">&times;</span>';
                html += '</div>';
                html += '<div class="wcps-compare-bar-item-name">' + product.name + '</div>';
                html += '</div>';
            });
            
            html += '</div>';
            html += '<div class="wcps-compare-bar-actions">';
            html += '<button class="wcps-compare-bar-clear">Clear All</button>';
            html += '<button class="wcps-compare-view-button">Compare Now</button>';
            html += '</div>';
            html += '</div>';
            html += '</div>';
            
            // Append to body
            $('body').append(html);
        },

        /**
         * Update Compare Bar
         */
        updateCompareBar: function(products) {
            var $compareBar = $('.wcps-compare-bar');
            
            if ($compareBar.length) {
                var $items = $compareBar.find('.wcps-compare-bar-items');
                $items.empty();
                
                // Add products
                $.each(products, function(index, product) {
                    var html = '<div class="wcps-compare-bar-item" data-product-id="' + product.id + '">';
                    html += '<div class="wcps-compare-bar-item-img">';
                    html += '<img src="' + product.image + '" alt="' + product.name + '">';
                    html += '<span class="wcps-compare-bar-item-remove" data-product-id="' + product.id + '">&times;</span>';
                    html += '</div>';
                    html += '<div class="wcps-compare-bar-item-name">' + product.name + '</div>';
                    html += '</div>';
                    
                    $items.append(html);
                });
            } else {
                // Create compare bar if it doesn't exist
                PRODDISP_Features.createCompareBar(products);
            }
        },

        /**
         * Initialize AJAX Add to Cart
         */
        initAjaxAddToCart: function() {
            $(document).on('click', '.wcps-add-to-cart-button', function(e) {
                e.preventDefault();
                var $button = $(this);
                var $row = $button.closest('tr');
                var $qtyInput = $row.find('.wcps-qty-input');
                var quantity = 1;
                if ($qtyInput.length) {
                    var val = parseInt($qtyInput.val(), 10);
                    if (!isNaN(val) && val > 0) {
                        quantity = val;
                    }
                }
                var productId = $button.data('product-id');
                // Skip if not simple product
                if ($button.hasClass('product_type_variable') || $button.hasClass('product_type_grouped')) {
                    window.location.href = $button.attr('href');
                    return;
                }
                // Store the original Add to Cart button HTML before AJAX
                var originalAddToCartHtml = $button.html();
                $button.prop('disabled', true).addClass('wcps-loading').html('<span class="wcps-btn-cta">Adding...</span>');
                $.ajax({
                    url: proddisp_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'proddisp_add_to_cart',
                        nonce: proddisp_params.nonce,
                        product_id: productId,
                        quantity: quantity
                    },
                    success: function(response) {
                        $button.prop('disabled', false).removeClass('wcps-loading').html(originalAddToCartHtml);
                        if (response.success) {
                            PRODDISP_Features.showNotification(response.data.message);
                            if (response.data.fragments) {
                                $.each(response.data.fragments, function(key, value) {
                                    $(key).replaceWith(value);
                                });
                            }
                            // Wait for the View cart link to appear, then update its HTML to match Add to Cart button (icon + text, etc)
                            setTimeout(function() {
                                var $actions = $button.closest('.wcps-product-actions');
                                var $viewCart = $actions.find('.added_to_cart.wc-forward:visible');
                                if ($viewCart.length) {
                                    var $temp = $('<div>' + originalAddToCartHtml + '</div>');
                                    // Change the icon for View cart
                                    $temp.find('.wcps-btn-icon i').attr('class', 'fas fa-arrow-right'); // Use arrow icon for View cart
                                    $temp.find('.wcps-btn-cta').text('View cart');
                                    $viewCart.html($temp.html());
                                }
                            }, 100);
                            $(document.body).trigger('added_to_cart', [response.data.fragments, response.data.cart_hash, $button]);
                        } else {
                            PRODDISP_Features.showNotification(response.data && response.data.message ? response.data.message : 'Error adding to cart', 'error');
                        }
                    },
                    error: function() {
                        $button.prop('disabled', false).removeClass('wcps-loading').html(originalAddToCartHtml);
                        PRODDISP_Features.showNotification('Error adding to cart', 'error');
                    }
                });
                return false;
            });
        },

        /**
         * Initialize quantity buttons
         */
        initQuantityButtons: function($context) {
            $context = $context || $('body');
            
            // Quantity buttons functionality
            $context.find('.wcps-quantity').each(function() {
                var $quantity = $(this);
                var $input = $quantity.find('.qty');
                var min = $input.attr('min') ? parseInt($input.attr('min')) : 1;
                var max = $input.attr('max') ? parseInt($input.attr('max')) : '';
                
                // Add plus/minus buttons if not already added
                if (!$quantity.find('.wcps-qty-button').length) {
                    $quantity.prepend('<span class="wcps-qty-button wcps-qty-minus">-</span>');
                    $quantity.append('<span class="wcps-qty-button wcps-qty-plus">+</span>');
                }
                
                // Minus button click
                $quantity.on('click', '.wcps-qty-minus', function() {
                    var val = parseInt($input.val()) - 1;
                    val = val < min ? min : val;
                    $input.val(val).trigger('change');
                });
                
                // Plus button click
                $quantity.on('click', '.wcps-qty-plus', function() {
                    var val = parseInt($input.val()) + 1;
                    val = (max && val > max) ? max : val;
                    $input.val(val).trigger('change');
                });
            });
        },

        /**
         * Show notification
         */
        showNotification: function(message, type) {
            type = type || 'success';
            
            // Remove existing notification
            $('.wcps-notification').remove();
            
            // Create notification
            var $notification = $('<div class="wcps-notification wcps-notification-' + type + '">' + message + '</div>');
            $('body').append($notification);
            
            // Show notification with animation
            setTimeout(function() {
                $notification.addClass('wcps-notification-show');
            }, 10);
            
            // Hide notification after delay
            setTimeout(function() {
                $notification.removeClass('wcps-notification-show');
                setTimeout(function() {
                    $notification.remove();
                }, 300);
            }, 3000);
        }
    };
    
    // Initialize on document ready
    $(document).ready(function() {
        PRODDISP_Features.init();
    });
    
    // Add this outside the AJAX handler, after PRODDISP_Features.initAjaxAddToCart definition
    $(document).on('click', '.wcps-view-cart-btn .wcps-btn-cta', function(e) {
        e.preventDefault();
        var $btn = $(this).closest('.wcps-view-cart-btn');
        var $hiddenViewCart = $btn.siblings('.added_to_cart.wc-forward:visible:first');
        if ($hiddenViewCart.length) {
            $hiddenViewCart[0].click();
        } else {
            window.location.href = '/cart/';
        }
    });
    
})(jQuery);